import { AppTreeSide, UniDateRangePicker } from 'components'
import ShowDataNode from '../../common/showDataNode'
import ssoLoginMixin from '@/mixins/sso-login-mixin.js' // 引入mixin文件
import convertorMixin from '@/mixins/convertor-mixin.js' // 引入mixin文件
import idNameMixin from '@/mixins/id-name-mixin.js' // 引入mixin文件
import typeImageMixin from '@/mixins/type-image-mixin.js' // 引入mixin文件
import tableSpanMixin from '@/mixins/table-span-mixin.js' // 引入mixin文件
import {getRegionList} from '@/api/get-data.js'
import {loadRegionTree, loadAuxMonitoringDeviceTreeItems} from '@/utils/tree'

export default {
  name: 'InfraredThermography',
  data () {
    return {
      // 侧边栏打开标志
      treeSideBarOpen: true,
      // 树数据
      treeData: [],
      auxMonitoringDevices: [], // 监控子设备数组
      treeNodeLoadedRegionIds: [], // 树节点已加载的区域id数组
      treeExpandedKeys: [], // 默认展开树节点key
      // 树查询条件
      treeQueryParams: {
        pageNum: 1,
        pageSize: 1000
      },
      // 默认树属性
      defaultTreeProps: {
        label: 'name' // name字段作为label
      },
      // 树节点显示过滤
      treeNodeFilter: '',
      filteredTreeData: [],
      // 活动页面索引
      activeTabName: '0',
      // 遮罩层
      loading: false,
      // 数据列表页面--------------------------------------------------------------------------------------------------
      // 表格数据
      tableData: [],
      tableTotalRow: 0,
      lastDataNodeUpdateDateTime: 0,
      // 表格查询条件
      tableQueryParams: {
        regionId: -1,
        nodeId: 0,
        descendantRegionRequired: 1,
        resourceKind: 255,
        gaugedObjectKind: 255,
        alarmStates: [],
        systemKind: this.systemKind,
        auxMonitoringDeviceId: -1, // 辅助监控设备id
        encoderStateRequired: 1, // 要求返回监控设备状态
        beginUpdateDateTime: 0,
        pageNum: 1,
        pageSize: 10
      },
      pageTotalCount: 0,
      pageNormalCount: 0,
      pageAlarmCount: 0,
      pageErrorCount: 0,
      // 表格当前行
      tableCurrentRow: null,
      // 数据节点信息弹窗
      showDataNodeModalOpen: false,
      // 轮巡定时器
      pollingTimer: null
    }
  },
  props: {
    systemKind: {
      type: Number,
      default() {
        return 3680 // 红外热成像
      }
    }
  },
  components: {
    AppTreeSide,
    UniDateRangePicker,
    ShowDataNode
  },
  mixins: [
    ssoLoginMixin,
    convertorMixin,
    idNameMixin,
    typeImageMixin,
    tableSpanMixin
  ],
  watch: {
    // 根据名称筛选节点
    treeNodeFilter(val) {
      this.$refs.tree.filter(val.trim())
    }
  },
  created() {
    // 显示或隐藏树侧边栏
    this.treeSideBarOpen = this.$globalConfig.treeSideBarOpen
    if (this.$route.query.treeSideBarOpen) {
      this.treeSideBarOpen = this.$route.query.treeSideBarOpen === '1' || this.$route.query.treeSideBarOpen === 'true'
    }
  },
  mounted () {
    // 单点登录（如url包含code和uiapTpye参数则启用单点登录）
    this.ssoLogin(this.$route.query.code, this.$route.query.uiapType).then(res => {
      // 获取区域列表
      this.getRegionList2()

      // 开始数据轮巡
      this.startDataPolling()
    })
  },
  beforeDestroy() {
    // 停止数据轮巡
    this.stopDataPolling()
  },
  methods: {
    // 显示或隐藏树侧边栏
    toggleTreeSideBar() {
      this.treeSideBarOpen = !this.treeSideBarOpen
    },
    // 查询区域列表
    getRegionList2() {
      getRegionList(this.$globalConfig.regionGettingFilterMode, () => {
        this.treeData = []
        this.treeData = loadRegionTree(this.$globalData.regions, this.treeData, false)
        this.$nextTick(() => {
          if (this.treeData.length > 0) {
            // 查询顶层区域下的视频节点列表
            this.getAuxMonitoringDeviceList(this.treeData[0].id)
            // 默认展开根节点
            this.treeExpandedKeys = [this.treeData[0].key]
            // 设置根节点或根节点的首个子节点为当前节点
            let currentKey = null
            if (this.$globalConfig.currentRegionSynchEnabled && this.$store.getters.appCurrentRegionKey) { // 区域同步选择启用
              currentKey = this.$store.getters.appCurrentRegionKey
            } else {
              if (this.$globalConfig.defaultCurrentTreeNode === 0) { // 根节点
                currentKey = this.treeData[0].key
              } else if (this.$globalConfig.defaultCurrentTreeNode === 1) { // 根节点的首个子节点
                currentKey = this.treeData[0].children.length > 0 ? this.treeData[0].children[0].key : this.treeData[0].key
              }
            }
            if (currentKey) {
              this.$refs.tree.setCurrentKey(currentKey)
              // 单击当前节点
              this.handleTreeNodeClick(this.$refs.tree.getCurrentNode())
            }
          }
        })
      })
    },
    // 查询辅助监控子设备列表
    getAuxMonitoringDeviceList(regionId) {
      // 检测该区域下辅助监控子设备是否已加载，防止重复加载
      if (this.treeNodeLoadedRegionIds.indexOf(regionId) !== -1) {
        return
      }

      this.$http(this.$api.auxMonitoringDeviceList, {
        regionId: regionId,
        descendantRegionRequired: 1,
        systemKind: this.systemKind,
        // resourceSubType: 120, // 红外成像仪
        pageNum: 1,
        pageSize: 1000
      }).then(
        res => {
          if (res.code === 200) {
            // 检测该区域下辅助监控子设备是否已加载，防止重复加载
            if (this.treeNodeLoadedRegionIds.indexOf(regionId) !== -1) {
              return
            }
            if (res.data.length) {
              res.data.forEach(item => {
                if (this.treeNodeLoadedRegionIds.indexOf(item.regionId) === -1) {
                  this.treeNodeLoadedRegionIds.push(item.regionId)
                }
              })

              this.auxMonitoringDevices = this.auxMonitoringDevices.concat(res.data)
              this.treeData = loadAuxMonitoringDeviceTreeItems(res.data, this.treeData)
              if (this.$refs.tree.getCurrentKey() && this.treeExpandedKeys.indexOf(this.$refs.tree.getCurrentKey()) === -1) {
                this.treeExpandedKeys = []
                this.treeExpandedKeys.push(this.$refs.tree.getCurrentKey()) // 展开父区域
              }
            }
            this.treeNodeLoadedRegionIds.push(regionId)
          }
        }).catch(err => {
        console.log(err)
      })
    },
    // 查询数据节点列表
    getDataNodeList() {
      this.loading = true
      this.lastDataNodeUpdateDateTime = 0
      this.tableQueryParams.beginUpdateDateTime = 0
      this.$http(this.$api.dataNodeList, this.tableQueryParams).then(
        res => {
          if (res.code === 200) {
            this.spanColumnIndexArr = [0, 1, 2] // 需要合并行的列索引数组
            this.getTableRowSpanArr(res.data, 'auxMonitoringDeviceId')

            this.tableData = res.data
            this.tableTotalRow = res.page.totalRow
            let groupNum = 1
            res.data.forEach((item, index) => {
              if (item.updateDateTime > this.lastDataNodeUpdateDateTime) { // 更新最后更新日期时间
                this.lastDataNodeUpdateDateTime = item.updateDateTime
              }

              item.groupNum = groupNum // 为每条记录设置组号
              if (this.rowSpanArr[index] > 0) { // 遇到下一组，累加组号
                ++groupNum
              }

              item.auxMonitoringDevice = this.getRecordById(item.auxMonitoringDeviceId, this.auxMonitoringDevices)
              if (item.auxMonitoringDevice) {
                item.installationPlace = item.auxMonitoringDevice.installationPlace
              } else {
                item.installationPlace = ''
              }
            })

            // if (res.data.length) {
            //   if (this.tableCurrentRow === null) {
            //     this.$refs.table.setCurrentRow(res.data[0]) // 选中首行
            //   } else {
            //     this.tableCurrentRow = this.getRecordById(this.tableCurrentRow.id, res.data)
            //     if (this.tableCurrentRow === null) { // 数组是否包含选中行
            //       this.$refs.table.setCurrentRow(res.data[0]) // 选中首行
            //     }
            //   }
            // }
          }
          this.loading = false
        }
      ).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    // 查询更新的数据节点列表
    getUpdatedDataNodeList() {
      this.loading = true
      this.tableQueryParams.beginUpdateDateTime = this.lastDataNodeUpdateDateTime + 1
      this.$http(this.$api.dataNodeList, this.tableQueryParams).then(
        res => {
          if (res.code === 200 && res.data.length) {
            res.data.forEach(item => { // 更新数据节点数据
              for (let index in this.tableData) {
                if (this.tableData[index].id === item.id) {
                  this.tableData[index] = item
                  break
                }
              }
              if (item.updateDateTime > this.lastDataNodeUpdateDateTime) { // 更新最后更新日期时间
                this.lastDataNodeUpdateDateTime = item.updateDateTime
              }
            })
          }
          this.loading = false
        }
      ).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    // 开始数据轮巡
    startDataPolling() {
      this.pollingTimer = setInterval(() => {
        if (this.loading) { // 检测上一次查询是否尚未结束
          return
        }
        if (this.showDataNodeModalOpen) { // 暂停刷新数据
          return
        }
        this.tableData.length ? this.getUpdatedDataNodeList() : this.getDataNodeList()
      }, this.$globalConfig.pagePollingInterval)
    },
    // 停止数据轮巡
    stopDataPolling() {
      if (this.pollingTimer != null) {
        clearInterval(this.pollingTimer)
        this.pollingTimer = null
      }
    },
    // 过滤树节点
    filterTreeNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    // 单击树节点
    handleTreeNodeClick(obj) {
      if (!obj) {
        return
      }

      if (obj.type === 'region') {
        // 查询辅助监控设备列表
        this.getAuxMonitoringDeviceList(obj.id)

        // 查询数据节点列表
        if (this.tableQueryParams.regionId !== obj.id) {
          this.tableQueryParams.regionId = obj.id
          this.tableQueryParams.auxMonitoringDeviceId = 0
          this.tableQueryParams.pageNum = 1
          this.getDataNodeList()

          if (this.$globalConfig.currentRegionSynchEnabled) { // 当前区域同步启用
            this.$store.commit('app/SET_CURRENT_REGION_KEY', obj.key) // 更新当前区域key
          }
        }
      } else if (obj.type === 'auxMonitoringDevice' && this.tableQueryParams.auxMonitoringDeviceId !== obj.id) {
        // 查询数据节点列表
        this.tableQueryParams.regionId = 0
        this.tableQueryParams.auxMonitoringDeviceId = obj.id
        this.tableQueryParams.pageNum = 1
        this.getDataNodeList()
      }
    },
    // 数据列表页面------------------------------------------------------------------------------------------------
    // 查询按钮操作
    handleFormQuery() {
      this.tableQueryParams.page = 1
      this.getDataNodeList()
    },
    // 重置按钮操作
    resetQueryForm() {
      this.tableQueryParams.regionId = 0
      this.tableQueryParams.nodeId = 0
      this.tableQueryParams.descendantRegionRequired = 1
      this.tableQueryParams.resourceKind = 255
      this.tableQueryParams.gaugedObjectKind = 255
      this.tableQueryParams.alarmStates = []
      this.tableQueryParams.pageNum = 1
      this.$refs['queryForm'].resetFields()
      this.handleFormQuery()
    },
    // 分页
    handleCurrentPageChange(val) {
      this.tableQueryParams.pageNum = val
      this.getDataNodeList()
    },
    // 页面条数改变
    handlePageSizeChange(val) {
      this.tableQueryParams.pageSize = val
      this.getDataNodeList()
    },
    // 表格当前记录改变
    handleTableCurrentChange(currentRow, oldCurrentRow) {
      if (currentRow == null) {
        return
      }
      this.tableCurrentRow = currentRow
    },
    // 查看数据节点信息
    handleDataNodeView(row) {
      if (row && row.id) {
        this.$refs.table.setCurrentRow(row) // 选中当前行
        this.showDataNodeModalOpen = true
      }
    },
    // 数据节点信息取消提交
    handleShowDataNodeModalCancel() {
      this.showDataNodeModalOpen = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/monitoring/infraredThermography/InfraredThermography.js